module.exports = __webpack_public_path__ + "img/neid.11f91085.png";